var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-list-item-meta',{attrs:{"title":_vm.officialName,"description":_vm.officialDesignation}},[_c('a-avatar',{attrs:{"slot":"avatar","size":48,"shape":"square","src":_vm.officialImageUrl},slot:"avatar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }